import { useState } from 'react'
import { Box, Card, CardBody, CardHeader, Flex, Heading } from '@chakra-ui/react'
import { UiBreadcrumb } from 'components/common'
import { UserForm, UserFormType } from './UserForm'
import { createUser } from 'api/userApi'
import { useAppContext } from 'hooks/useAppContext'
import { useNavigate } from 'react-router-dom'

const BreadcrumbNav = [
  {
    label: 'User Management',
    path: '/system/users'
  },
  {
    label: 'Add User',
    path: '/system/users/add',
    isCurrentPage: true
  }
]

export const AddUser = () => {
  const navigate = useNavigate()
  const { createToast } = useAppContext()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [formError, setFormError] = useState(null)

  const handleAdd = async (form) => {
    setIsSubmitting(true)

    try {
      await createUser({
        firstname: form.firstname,
        lastname: form.lastname,
        email: form.email,
        phone: form.phone,
        password: form.password,
        role: form.role
      })
      createToast('success', 'User created')
      navigate('/system/users')
      setIsSubmitting(false)
    } catch (err) {
      if (err.response.status === 400) {
        setFormError(err.response.data)
      } else {
        createToast('error', 'Error', err.response.data)
      }
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        <Flex justifyContent="space-between" alignItems="center" my={8}>
          <Heading size="lg">Add User</Heading>
        </Flex>
        <Card borderRadius={0}>
          <CardHeader bg="gray.500" p={4}>
            <Heading color="white" size="sm">User Information</Heading>
          </CardHeader>
          <CardBody p={8}>
            <UserForm
              type={UserFormType.Add}
              onSubmit={handleAdd}
              isSubmitting={isSubmitting}
              initialFormError={formError}
            />
          </CardBody>
        </Card>
      </Box>
    </>
  )
}
